import React from "react";
import { Helmet } from "react-helmet";

const MetaTags = ({ title, description, image, url, extra = [] }) => (
  <Helmet>
    {title && <title>{title}</title>}
    {description && <meta name="description" content={description} />}
    {image && <meta property="og:image" content={image} />}
    {url && <meta property="og:url" content={url} />}
    {title && <meta property="og:title" content={title} />}
    {description && <meta property="og:description" content={description} />}
    {extra.map((props, i) => (
      <meta key={i} {...props} />
    ))}
  </Helmet>
);

export default MetaTags;
